import { render } from "./DividerStoryComponent.vue?vue&type=template&id=3c96fbae&scoped=true"
import script from "./DividerStoryComponent.vue?vue&type=script&lang=js"
export * from "./DividerStoryComponent.vue?vue&type=script&lang=js"

import "./DividerStoryComponent.vue?vue&type=style&index=0&id=3c96fbae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c96fbae"]])

export default __exports__